/* Variant → media swap (by media ID, index-agnostic) */
(function () {
  function boot() {
    var main =
      document.querySelector('[data-product-gallery]') ||
      document.querySelector('.product_gallery');
    if (!main) return;

    function getFlkty(el) {
      return el?._flickity ||
             el?.flickity ||
             (window.jQuery && el && (jQuery(el).data('flickity') || jQuery(el).data('flickityInstance'))) ||
             (window.Flickity && el && window.Flickity.data && window.Flickity.data(el)) ||
             null;
    }

    function getProductJSON() {
      var el = document.querySelector('script[id^="ProductJSON-"],script[id^="ProductJson-"]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    function findVariantById(id) {
      var p = getProductJSON();
      if (!p?.variants || !id) return null;
      return p.variants.find(function (v) { return String(v.id) === String(id); }) || null;
    }

    function selectByIndex(idx) {
      if (idx < 0) return false;
      var cells = Array.from(main.querySelectorAll('.gallery-cell'));
      var slide = cells[idx];
      var flkty = getFlkty(main);
      if (flkty && typeof flkty.select === 'function') {
        flkty.select(idx, false, true);
      } else {
        slide?.scrollIntoView({ block: 'nearest' });
      }

      var productId = main.getAttribute('data-product-id');
      var nav =
        (productId && document.querySelector('.product-' + productId + '-gallery-nav')) ||
        document.querySelector('.product-gallery__thumbnails') ||
        document.querySelector('.product_gallery_nav');
      if (nav) {
        var nflk = getFlkty(nav);
        if (nflk && typeof nflk.select === 'function') nflk.select(idx, false, true);
      }
      return true;
    }

    function selectByMediaId(id) {
      if (!id) return false;

      var nav =
        document.querySelector('.product-gallery__thumbnails') ||
        document.querySelector('.product_gallery_nav') ||
        document;
      var thumbs = Array.from(nav.querySelectorAll('.product-gallery__thumbnail'));
      var idx = thumbs.findIndex(function (el) {
        return String(el.getAttribute('data-media-id')) === String(id);
      });
      if (idx >= 0) return selectByIndex(idx);

      var cells = Array.from(main.querySelectorAll('.gallery-cell'));
      var slide = main.querySelector('.gallery-cell[data-media-id="' + id + '"]');
      if (slide) return selectByIndex(cells.indexOf(slide));

      var link = document.querySelector('[aria-controls$="-' + id + '"]');
      if (link) { link.click(); return true; }

      return false;
    }

    function getCurrentVariantId() {
      var form = document.querySelector('form[action*="/cart/add"]');
      var idField = form?.querySelector('input[name="id"], select[name="id"]');
      if (idField?.value) return idField.value;

      var urlId = new URLSearchParams(location.search).get('variant');
      if (urlId) return urlId;

      return null;
    }

    function applyFromCurrentVariant() {
      var vid = getCurrentVariantId();
      var variant = findVariantById(vid);
      var mediaId = variant?.featured_media?.id || variant?.featured_media_id || variant?.image_id || null;
      if (mediaId) selectByMediaId(mediaId);
    }

    applyFromCurrentVariant();

    document.addEventListener('variant:change', function (e) {
      var v = e.detail?.variant;
      var id = v?.featured_media?.id || v?.featured_media_id || v?.image_id;
      if (id) selectByMediaId(id);
    });

    document.addEventListener('variant:changed', function (e) {
      var v = e.detail?.variant;
      var id = v?.featured_media?.id || v?.featured_media_id || v?.image_id;
      if (id) selectByMediaId(id);
    });

    document.addEventListener('yt:product-gallery:ready', function (e) {
      if (e.detail?.gallery === main) {
        applyFromCurrentVariant();
      }
    });

    if (window.jQuery) {
      jQuery(main).on('ready.flickity', function () {
        applyFromCurrentVariant();
      });
    }

    var form = document.querySelector('form[action*="/cart/add"]') || document;
    var obs = new MutationObserver(function () {
      applyFromCurrentVariant();
    });
    obs.observe(form, { subtree: true, childList: true, attributes: true, characterData: true });

    document.addEventListener('change', function (e) {
      var n = e.target?.name || '';
      if (n === 'id' || /^option[1-3]$/.test(n) || n.indexOf('options[') === 0) {
        applyFromCurrentVariant();
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
